import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    scrollMargin: '5rem 0',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '0.5rem',
    boxSizing: 'border-box',
    borderRadius: '0.75rem',
    width: '100%',
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.35)',
    padding: '0.5rem',
    background: 'white',
    fontSize: theme.size.sm,

    '& > :not(:first-child)': {
      marginTop: '0.5rem'
    },

    '&:last-child': {
      marginBottom: '0'
    }
  }
}))

export default useStyles
